import { useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

// One shared matchMedia listener for the whole app instead of a resize handler
// per component. Components subscribing to the same store also re-render in the
// same tick, so panels and their headers never disagree about the breakpoint.
const getQuery = () =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;

function subscribe(onChange) {
    const query = getQuery();
    if (!query) return () => { };
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
}

function getSnapshot() {
    const query = getQuery();
    return query ? query.matches : false;
}

/**
 * True below the `md` Tailwind breakpoint (768px).
 * Replaces the near-identical hook that was re-declared in five files.
 */
export function useIsMobile() {
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export default useIsMobile;
